module.exports = __webpack_public_path__ + "static/media/Leaf-Spring_355x237.42ac7619.jpg";